import { RegionCollection } from "@opendaw/lib-dsp";
import { assert, Listeners, Notifier, Terminator, UUID } from "@opendaw/lib-std";
import { Pointers } from "@opendaw/studio-enums";
import { RegionAdapters, RegionComparator } from "./RegionBoxAdapter";
export class TrackRegions {
    #trackBoxAdapter;
    #terminator;
    #changeNotifier;
    #regionsListeners;
    #collection;
    #adapters;
    constructor(adapter, boxAdapters) {
        this.#trackBoxAdapter = adapter;
        this.#terminator = new Terminator();
        this.#changeNotifier = this.#terminator.own(new Notifier());
        this.#regionsListeners = this.#terminator.own(new Listeners());
        this.#collection = RegionCollection.create(RegionComparator);
        this.#adapters = UUID.newSet(adapter => adapter.uuid);
        this.#terminator.ownAll(this.#trackBoxAdapter.box.regions.pointerHub.catchupAndSubscribe({
            onAdded: ({ box }) => {
                const adapter = RegionAdapters.for(boxAdapters, box);
                const added = this.#adapters.add(adapter);
                assert(added, `Cannot add ${box}`);
                this.#collection.add(adapter);
                this.#regionsListeners.forEach(listener => listener.onAdded(adapter));
                this.dispatchChange();
            },
            onRemoved: ({ box: { address: { uuid } } }) => {
                const adapter = this.#adapters.removeByKey(uuid);
                this.#collection.remove(adapter);
                this.#regionsListeners.forEach(listener => listener.onRemoved(adapter));
                this.dispatchChange();
            }
        }, Pointers.RegionCollection));
    }
    get trackBoxAdapter() { return this.#trackBoxAdapter; }
    get collection() { return this.#collection; }
    get adapters() { return this.#adapters; }
    onIndexingChanged() {
        this.#collection.onIndexingChanged();
        this.dispatchChange();
    }
    catchupAndSubscribe(listener) {
        this.collection.asArray().forEach(listener.onAdded);
        return this.#regionsListeners.subscribe(listener);
    }
    subscribeChanges(observer) { return this.#changeNotifier.subscribe(observer); }
    dispatchChange() { this.#changeNotifier.notify(); }
    terminate() { this.#terminator.terminate(); }
}
